// extracted by mini-css-extract-plugin
export default {"container":"Header_container__0zUkW","title":"Header_title__pEnmT","timer":"Header_timer__rgdvM","timerIcon":"Header_timerIcon__vdRol","timerText":"Header_timerText__qPGLf"};